const getBrandModelAttributes = (serverVariant) => ({
  brandModelCode: serverVariant.variantTypeDetails.brandModelCode ?? void 0,
  brandModelColorCode: serverVariant.variantTypeDetails.brandModelColorCode ?? void 0
});
export {
  getBrandModelAttributes
};
//# sourceMappingURL=get-brand-model-attributes.js.map
